
<ng-container *ngFor="let item of filterItemsDisplay;trackBy:trackByfilterId" >
    <div (click)="onChangeSelectedFilter(item)" 
    *ngIf="item.showZeroCountFilter || (item.count != '-1' && item.count != '0')"
    class="filter-buckets" 
    [ngClass]="{'highlightFilter': selectedFilterItem.id === item.id}">
        <div class="filter-count showLoading" *ngIf="item.count == '-1'" ></div>
        <div class="filter-count" *ngIf="item.count != '-1'">{{item.count}}</div>
        <div class="filter-category-caption">{{item.name}}</div>
    </div>
</ng-container>
